import { useEffect, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import Context from '../../context';
import WeatherScreen from '../Weather';
import './Weather.scss';

const Weather = () => {
  const [data, setData] = useState(null);
  const { itin } = useContext(Context);
  const { slideNum } = useParams();

  useEffect(() => {
    const location = itin.locations.find(loc => loc.id === itin.brief[parseInt(slideNum) - 1]?.locationId);
    setData(location);
  }, [itin.brief, itin.locations, slideNum]);

  if (!data) return <div>Loading</div>;

  return (
    <WeatherScreen type='daily' location={data} />
  );
};

export default Weather;
